module.exports = __webpack_public_path__ + "static/CampaignManagement-cb986b513db4bd8cf69b66ee6be18dce.jpg";